(function () {
  angular.module('MktzapApp.Factories')
    .factory('BadwordsConfigService', BadwordsConfigService);

    BadwordsConfigService.$inject = ['$resource'];

  function BadwordsConfigService ($resource) {
    return $resource('', {}, {
      getConfigs: { url: frontUrl + '/badwords-get', method: 'GET', isArray: false },
      saveConfigs: { url: frontUrl + '/badwords-update-create', method: 'POST', params: {}, isArray: false },
      filterMessage: { url: frontUrl + '/badwords-check', method: 'POST', params: {}, isArray: false },
      saveReportData: { url: frontUrl + '/save-badwords-data', method: 'POST', params: {}, isArray: false },
      uploadFile: { url: frontUrl + '/upload-badwords-data', method: 'POST', params: {}, isArray: false }
    });
  }
})();
